goog.provide('el8.util.feed');
goog.provide('el8.util.feed.loadImages');

goog.require('el8.template.util.feed');
goog.require('el8.service.tz');


el8.util.feed = (function() {
    return {
        getFeedItemId: function(feedName, item) {
            var str = feedName ? feedName + '_' : '';
            if (item.isPreview && item.isPreview()) { str += 'preview_'; }
            return str + item.getFeedItemId();
        },
        getNoteFeedItemId: function( item ) { return el8.util.feed.getFeedItemId( 'note', item ); },
        getVisitNoteFeedItemId: function( item ) { return el8.util.feed.getFeedItemId( 'visit', item ); },
        getChartFeedItemId: function( item ) { return el8.util.feed.getFeedItemId( 'chart', item ); },
        getReportFeedItemId: function( item ) { return el8.util.feed.getFeedItemId( 'report', item ); },
        getLastViewedItemId: function( item ) { return el8.util.feed.getFeedItemId( 'last', item ); },
        getSearchResultsFeedItemId: function( item ) { return el8.util.feed.getFeedItemId( 'search', item ); },
        fromFeedItemId: function(feedItemId) {
            // DEBUGGING cannot call method 'split' of undefined
            try {
                var strs = feedItemId.split('_');
                return {
                    id: strs[strs.length-1]*1,
                    model_class: strs[strs.length-2]
                };
            } catch (e) {
                UIM && UIM.logError(e.stack ? e.stack : e.message);
                return null;
            }
        }
    };
})();

el8.util.feed.loadImages = function(spec) {

    for (var i=0; i<spec.images.length; i++) {
        var imageId = 'images_'+i;
        var $elt = $('.'+imageId, spec.container).first();

        el8.util.feed.loadSingleImage($elt, {
            maxWidth: spec.width,
            imageClass: spec.imageClass,
            imageWrapClass: spec.imageWrapClass,
            imageWrapSelector: spec.imageWrapSelector,
            fid: spec.item.getFeedItemId(),
            successCb: spec.successCb,
            zoomable: spec.zoomable
        });
    }

};

el8.util.feed.loadSingleImage = function($elt, spec) {

    spec = spec || {};
    var imageClass = spec.imageClass || null;
    var forceRefresh = (spec.forceRefresh === true); // defaults to false
    var width = spec.width || null;
    var maxWidth = spec.maxWidth || null;
    var successCb = spec.successCb || null;
    var errorCb = spec.errorCb || null;
    var zoomable = (spec.zoomable !== false); // defaults to true
    var showZoomableCursor = (spec.showZoomableCursor !== false);
    var imageWrapSelector = spec.imageWrapSelector || null;
    var imageWrapClass = spec.imageWrapClass || null;
    var fid = spec.fid || null;

    var $imgElt = $('.image-item', $elt);
    if (!$imgElt.length) { $imgElt = $elt; }
    $imgElt.addClass('imageLoading');

    if (imageWrapSelector) {
        var $wrap = $imgElt.closest(imageWrapSelector);
        successCb = function($newImg) {
            var width = $newImg.width();
            var height = $newImg.height();
            if (width) { $wrap.outerWidth(width); }
            if (height) { $wrap.height(height); }
            if (imageWrapClass) { $wrap.addClass(imageWrapClass); }
            if (spec.successCb) { spec.successCb(); }
        };
    }

    var id = $imgElt.attr('data-id');
    var src = $imgElt.attr('data-src');
    if (forceRefresh) {
        var rIndex = src.indexOf('&r=');
        src = src.substring(0, rIndex) + '&r=' + Math.random();
    }
    var img = new Image();
    $(img)
        .attr('data-id', id)
        .attr('src', src)
        .on('load', function() {
            var $newImg = $(this);
            $newImg.hide();
            $imgElt.replaceWith($newImg);
            if (imageClass) { $newImg.addClass(imageClass); }
            if (width) {
                $newImg.outerWidth(width);
            } else if (maxWidth) {
                $newImg.css('max-width', maxWidth);
            }
            if (zoomable !== false) {
                $newImg.addClass('zoomable');
                if (showZoomableCursor) { $newImg.addClass('el8Zoomable'); }
                if (fid) { $newImg.attr('_fid', fid); }
            }
            $newImg.fadeIn(function() {
                if (successCb) { successCb($newImg); }
            });
        })
        .on('error', function() {
            var $failed = $(el8.template.util.feed.failedImage());
            $imgElt.replaceWith($failed);
            if (errorCb) { errorCb($failed); }
        });

};


